import { render, staticRenderFns } from "./MessageDetails.vue?vue&type=template&id=0b03c8be&scoped=true"
import script from "./MessageDetails.vue?vue&type=script&lang=js"
export * from "./MessageDetails.vue?vue&type=script&lang=js"
import style0 from "./MessageDetails.vue?vue&type=style&index=0&id=0b03c8be&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b03c8be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b03c8be')) {
      api.createRecord('0b03c8be', component.options)
    } else {
      api.reload('0b03c8be', component.options)
    }
    module.hot.accept("./MessageDetails.vue?vue&type=template&id=0b03c8be&scoped=true", function () {
      api.rerender('0b03c8be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessageCenter/MessageDetails.vue"
export default component.exports